import type { PeopleInsightsData } from 'modules/job_catalog/lib/peopleInsights'

import { JobCatalogGenderData } from './models'

const roundToTwoDecimals = (num: number): number => Math.round((num + Number.EPSILON) * 100) / 100

export const useJobCatalogGenderDataFromInsights = (
  insights: PeopleInsightsData,
  isLevel: boolean
) => {
  const { totalCount, maleCount, femaleCount, notDeclaredCount, groups } = insights

  let data: JobCatalogGenderData[]
  let keys: string[]
  const nameById: Record<string, string> = {}

  if (!isLevel && groups.length > 0) {
    data = groups.map((group) => {
      nameById[group.nodeGroupId] = group.nodeGroupName
      return {
        id: group.nodeGroupId,
        Men: group.maleCount,
        Women: group.femaleCount,
        'Not declared': group.notDeclaredCount,
      }
    })
    keys = ['Men', 'Women', 'Not declared']
  } else {
    data = [
      { id: 'Men', Total: maleCount },
      { id: 'Women', Total: femaleCount },
      { id: 'Not declared', Total: notDeclaredCount },
    ]
    keys = ['Total']
  }

  const safePercentage = (count: number) =>
    totalCount > 0 ? roundToTwoDecimals((count / totalCount) * 100) : 0

  return {
    data,
    keys,
    nameById,
    count: totalCount,
    malePercentage: safePercentage(maleCount),
    femalePercentage: safePercentage(femaleCount),
    notDeclaredPercentage: safePercentage(notDeclaredCount),
  }
}
